/**
 * Columns definition for the Round By Round votes table
 *
 * @param isWeekly
 * @param isPredictor
 * @returns {Array} Columns list
 */
export const composeColumnData = (isWeekly, isPredictor) => {
    let columns = [
        {
            Header: isWeekly ? 'Week' : 'Rd',
            accessor: 'roundNumber'
        },
        {
            Header: 'Opponent',
            accessor: 'opponent'
        },
        ...(!isWeekly
            ? [
                  {
                      Header: isPredictor ? 'Predicted Votes' : 'Predicted',
                      accessor: 'predictedPoints'
                  }
              ]
            : []),
        ...(!isPredictor
            ? [
                  {
                      Header: 'Votes',
                      accessor: 'votes'
                  }
              ]
            : [])
    ];

    return columns;
};
